export default __webpack_public_path__ + "static/quick-view-panel-d8bfa9bdb67b841b856b6b30f487e0de.png";